import { createContext } from 'react';

export interface IBreakPointsProviderProps {
  children: React.ReactNode;
  isMobile: boolean;
}

const BreakPointsContext = createContext<{
  isMobile: boolean;
}>({
  isMobile: false,
});

function BreakPointsProvider({
  children,
  isMobile,
}: IBreakPointsProviderProps) {
  return (
    <BreakPointsContext.Provider
      value={{
        isMobile,
      }}
    >
      {children}
    </BreakPointsContext.Provider>
  );
}

export { BreakPointsContext, BreakPointsProvider };
